
import { defineComponent, ref } from "vue";
import { PropertyOption } from "@/types";
import ValuePreview from "./ValuePreview.vue";

export default defineComponent({
  name: "ValueGroupPreview",
  props: {
    group: {
      type: Array as () => {
        property: PropertyOption;
        value: number;
      }[],
      required: true
    }
  },
  components: { ValuePreview },
  setup() {
    const active = ref(false);

    const mouseOver = () => (active.value = true);
    const mouseLeave = () => (active.value = false);

    return { active, mouseOver, mouseLeave };
  }
});
